var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export default function VerticalSeparator() {
    return _jsx(Container, {});
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: linear-gradient(180deg, rgba(212, 180, 127, 0) 0%, #d5b581e1 50%, rgba(213, 181, 129, 0) 100%);\n  flex-shrink: 0;\n  height: 100%;\n  width: 1px;\n"], ["\n  background: linear-gradient(180deg, rgba(212, 180, 127, 0) 0%, #d5b581e1 50%, rgba(213, 181, 129, 0) 100%);\n  flex-shrink: 0;\n  height: 100%;\n  width: 1px;\n"])));
var templateObject_1;
